import React, {Fragment, useState} from "react";
import {Dialog, Transition} from "@headlessui/react";

interface SortDataProps {
    orderList: Array<{ key: string; name: string }>;
    setOrder: React.Dispatch<React.SetStateAction<string>>;
    initialSelected?: string | undefined;
    isOpen: boolean;
    setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
    onClose: () => void;
    selectedName: React.Dispatch<React.SetStateAction<string>>;
}

export const SortDataMobile: React.FC<SortDataProps> = ({
                                                            orderList,
                                                            setOrder,
                                                            initialSelected,
                                                            isOpen,
                                                            setIsOpen,
                                                            onClose,
                                                            selectedName,
                                                        }) => {
    const [selected, setSelected] = useState(initialSelected ? initialSelected : "");

    const handleClick = ({order, name}: { order: string, name: string }) => {
        setIsOpen(false);
        setOrder(order);
        setSelected(order);
        selectedName(name);
    };

    return (
        <>
            {/*Mobile View*/}
            <div className="block lg:hidden">
                <Transition.Root show={isOpen} as={Fragment}>
                    <Dialog as="div" onClose={onClose} className="relative z-0 lg:hidden">
                        <Transition.Child
                            as={Fragment}
                            enter="ease-out duration-200"
                            enterFrom="opacity-0"
                            enterTo="opacity-100"
                            leave="ease-in duration-150"
                            leaveFrom="opacity-100"
                            leaveTo="opacity-0"
                        >
                            <div className="fixed backdrop-blur-[2px] inset-0 bg-opacity-40 transition-opacity"/>
                        </Transition.Child>

                        <div className="fixed bottom-16 inset-0 flex items-end justify-center">
                            <Transition.Child
                                as={Fragment}
                                enter="ease-out duration-300"
                                enterFrom="translate-y-full"
                                enterTo="translate-y-0"
                                leave="ease-in duration-200"
                                leaveFrom="translate-y-0"
                                leaveTo="translate-y-full"
                            >
                                <Dialog.Panel
                                    className="w-full bg-white min-h-48 border-t border-gray-400 overflow-y-auto">
                                    <div className="w-12 h-1.5 bg-gray-300 rounded-full mx-auto mt-2 mb-1"/>
                                    <div className="flex items-center justify-between px-4 pb-2">
                                        <Dialog.Title
                                            className="font-bold text-black p-1 text-sm">
                                            مرتب سازی بر اساس
                                        </Dialog.Title>
                                        <button
                                            onClick={onClose}
                                            className="text-gray-500 scale-125 hover:text-gray-800 transition"
                                            aria-label="بستن اعلان‌ها"
                                        >
                                            ✕
                                        </button>
                                    </div>
                                    {orderList.length > 0 && (
                                        orderList.map((item, index) => {
                                            return (
                                                <>
                                                    <div
                                                        key={index}
                                                        className={`text-sm py-3 px-5 cursor-pointer ${selected === item.key ? "text-customColor font-bold" : "font-normal text-gray-500"}`}
                                                        onClick={() => handleClick({ order: item.key, name: item.name })}
                                                    >
                                                        {item.name}
                                                    </div>
                                                    <hr className="text-gray-300"/>
                                                </>
                                            )
                                        })
                                    )}
                                </Dialog.Panel>
                            </Transition.Child>
                        </div>
                    </Dialog>
                </Transition.Root>
            </div>
        </>
    );
};